import { motion } from "framer-motion";

const STOPS = [
  { year: "2026", name: "Mother Stall", body: "Flagship khokas. Nail the product, the queue and the numbers.", tag: "3 COMPANY KHOKAS" },
  { year: "2027", name: "Local → Express", body: "First franchise batch across Maharashtra. Central kitchen for chutneys and vada mix goes live.", tag: "25 OUTLETS" },
  { year: "2028", name: "Junction", body: "Metro cities + campus & airport formats. Delivery-only cloud khokas ride the aggregator rails.", tag: "100 OUTLETS • 8 CITIES" },
  { year: "2030", name: "Vada Videsh", body: "Dubai, Singapore, London — wherever Bombay hearts queue, the footlong follows.", tag: "THE DREAM" },
];

export const LineMap = () => (
  <section id="linemap" data-testid="linemap-section" className="bg-pav py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-4 sm:px-6">
      <p className="text-center font-bungee text-xs tracking-[0.35em] text-mirchi sm:text-sm">THE LINE MAP</p>
      <h2 className="mt-4 text-center font-shrikhand text-4xl text-kadak sm:text-5xl lg:text-6xl">
        Bombay first. <span className="text-mirchi">Bharat next.</span>
      </h2>
      <div className="relative mt-16">
        <div className="absolute left-4 top-0 h-full w-1 border-l-4 border-dashed border-mirchi/60 md:left-0 md:top-6 md:h-1 md:w-full md:border-l-0 md:border-t-4" />
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          {STOPS.map((s, i) => (
            <motion.div
              key={s.year}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.4, delay: i * 0.12 }}
              className="relative pl-12 md:pl-0 md:pt-16"
            >
              <span className="absolute left-2 top-1 h-6 w-6 rounded-full border-4 border-mirchi bg-taxi md:left-1/2 md:top-0 md:-translate-x-1/2" />
              <p className="font-bungee text-xs tracking-widest text-kadak/50">{s.tag}</p>
              <p className="mt-1 font-bungee text-2xl text-mirchi">{s.year}</p>
              <h3 className="mt-1 font-shrikhand text-2xl text-kadak">{s.name}</h3>
              <p className="mt-2 text-sm text-kadak/70">{s.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
      <p className="mt-16 text-center font-bungee text-sm tracking-[0.4em] text-mirchi">NEXT STATION: EVERYWHERE</p>
    </div>
  </section>
);
